export default __webpack_public_path__ + "media/images/avatars/avatar3-a71f9311b1b4ace47a98c407fe671714.png";